/* template */
<template><page><div :class='["loading-page"]'><base-container><div :class='["describe"]'>默认大小</div><cube-loading></cube-loading><div :class='["describe"]'>36大小</div><cube-loading :size="(36)"></cube-loading><div :class='["describe"]'>48大小</div><cube-loading :size="(48)"></cube-loading></base-container></div></page></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_56dc78ac"}'>
.loading-page
  padding-top: 10px
  height 100%
  background-color rgba(239, 239, 244, .7)
  .describe
    margin: 10px 0
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_56dc78ac"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_56dc78ac"}
  /** script content **/
  require("./index.mpx.js?isPage!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=page&index=0&isPage&lang=js&mpx&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_56dc78ac"],
    ctorType: "page",
    outputPath: "",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'base-container':getComponent(require("../../components/base-container/index.mpx?isComponent&outputPath=components%2Findexa53ae8d2%2Findex")),'cube-loading':getComponent(require("../../../packages/mpx-cube-ui/src/components/loading/index.mpx?isComponent&outputPath=components%2Findex017e6569%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>